<template>
    <b-modal
        v-model="show"
        centered
        :title="title"
        lazy
    >
        Are you sure you want to remove this venue from this event?

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="reset"
            >
                Close
            </b-btn>
            <Button
                variant="danger"
                @click="deleteVenue"
            >
                Remove venue
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { get, call } from 'vuex-pathify';

export default {
    props: {
        title: {
            type: String,
            default: 'Remove venue',
        },
    },
    computed: {
        show: get('venues/showDeleteVenueModal'),
    },
    methods: {
        reset: call('venues/deleteVenue', null),
        deleteVenue: call('venues/deleteVenue'),
    },
};
</script>

<style scoped>

</style>
